// WICHTIG: muss vor allen anderen Imports stehen. Stellt auf älteren Browsern
// (z.B. Safari 12 auf dem iPhone 6, letztes verfügbares iOS für dieses
// Gerät) fehlende JavaScript-Funktionen bereit, die im Code verwendet
// werden (z.B. Promise.allSettled) — ohne das bleibt die Seite dort
// komplett weiß, weil das Skript beim Parsen abbricht.
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Service Worker registrieren (PWA)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('SW registriert:', reg.scope))
      .catch((err) => console.warn('SW Fehler:', err));
  });
}
